import Button from "../../UI/Button/Button";
const ViewClientVideo = (props) => {

    return (
        <div className="row justify-content-center">
            <div className="col-6">
                <div className="row justify-content-center">
                    <video
                        aria-label="kkkk"
                        className="VideoInput_video"
                        width="100%"
                        height={300}
                        controls
                        src={props.clientVideo.downloadUrl}
                    />
                </div>
                <div className="row justify-content-center mt-4">
                    <Button btnType="General" clicked={props.back} >برگشت</Button>
                </div>
            </div>
        </div>
    )
}

export default ViewClientVideo;